import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";


export const fetchAllSelfPublishings = async ({ auth, page = 0, size = 20, onSuccess = null, onError = null }) => {
    try {
        const url = `${BACKEND_API_URL}/self-publishing?page=${page}&size=${size}`;

        const response = await fetchWithAuth(
            url,
            {
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "getAllSelfPublishings");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
};

export const fetchAllSelfPublishingsPersonal = async ({ auth, onSuccess = null, onError = null }) => {
    try {
        const url = `${BACKEND_API_URL}/self-publishing/personal`;

        const response = await fetchWithAuth(
            url,
            {
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchAllSelfPublishingsPersonal");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
};

export const createSelfPublishingEntry = async ({ auth, payload, files = null, onSuccess = null, onError = null }) => {
    try {
        const formData = new FormData();

        formData.append("payload", new Blob([JSON.stringify(payload)], { type: "application/json" }));

        if (Array.isArray(files) && files.length > 0) {
            files.forEach((file) => {
                formData.append("files", file);
            });
        }

        let response = null;
        if (auth) {
            response = await fetchWithAuth(
                `${BACKEND_API_URL}/self-publishing`,
                {
                    method: 'POST',
                    body: formData
                },
                auth
            );
        } else {
            response = await fetch(
                `${BACKEND_API_URL}/self-publishing/guest`,
                {
                    method: 'POST',
                    body: formData
                },
            );

        }

        const data = await handleApiResponse(response, "createSelfPublishingEntry");

        if (onSuccess) onSuccess(data);
        return data;

    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
};

export const fetchSelfPublishingDetailed = async ({ auth, selfPublishingId, onSuccess = null, onError = null }) => {
    try {
        if (!selfPublishingId) return null;

        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/self-publishing/detailed/${selfPublishingId}`,
            {
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchSelfPublishingDetailed");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const fetchSelfPublishingDetailedPersonal = async ({ auth, selfPublishingId, onSuccess = null, onError = null }) => {
    try {
        if (!selfPublishingId) return null;

        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/self-publishing/personal/detailed/${selfPublishingId}`,
            {
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchSelfPublishingDetailedPersonal");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const deleteSelfPublishing = async ({ auth, selfPublishingId, onSuccess = null, onError = null }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/self-publishing/${selfPublishingId}`,
            { method: 'DELETE' },
            auth
        );

        const data = await handleApiResponse(response, "deleteSelfPublishing");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}